import type { UnknownEnum } from './unknown-value.interface';

export enum DeviceDiskUsed {
  Low = "LOW",
  Fifty = "50",
  Sixty = "60",
  Seventy = "70",
  Eighty = "80",
  Ninety = "90",
}

export type DeviceDiskUsedOrUnknown = DeviceDiskUsed | UnknownEnum;